/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { ThirdPartyViewModel } from './ThirdPartyViewModel';
import {
    ThirdPartyViewModelFromJSON,
    ThirdPartyViewModelFromJSONTyped,
    ThirdPartyViewModelToJSON,
} from './ThirdPartyViewModel';

/**
 * 
 * @export
 * @interface JustPortfolioViewModel
 */
export interface JustPortfolioViewModel {
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    cashAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    unitAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    assetCode?: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    incomeAmount?: number;
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof JustPortfolioViewModel
     */
    disinvestmentTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof JustPortfolioViewModel
     */
    spousalInd?: IAPYESORNO;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    spousalPerc?: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioViewModel
     */
    minInvestmentPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof JustPortfolioViewModel
     */
    quoteNumber?: string;
    /**
     * 
     * @type {ThirdPartyViewModel}
     * @memberof JustPortfolioViewModel
     */
    thirdPartyViewModel?: ThirdPartyViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof JustPortfolioViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the JustPortfolioViewModel interface.
 */
export function instanceOfJustPortfolioViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function JustPortfolioViewModelFromJSON(json: any): JustPortfolioViewModel {
    return JustPortfolioViewModelFromJSONTyped(json, false);
}

export function JustPortfolioViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JustPortfolioViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'productId': json['ProductId'],
        'cashAmount': !exists(json, 'CashAmount') ? undefined : json['CashAmount'],
        'unitAmount': !exists(json, 'UnitAmount') ? undefined : json['UnitAmount'],
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'incomeAmount': !exists(json, 'IncomeAmount') ? undefined : json['IncomeAmount'],
        'disinvestmentTypeId': !exists(json, 'DisinvestmentTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['DisinvestmentTypeId']),
        'spousalInd': !exists(json, 'SpousalInd') ? undefined : IAPYESORNOFromJSON(json['SpousalInd']),
        'spousalPerc': !exists(json, 'SpousalPerc') ? undefined : json['SpousalPerc'],
        'minInvestmentPeriod': !exists(json, 'MinInvestmentPeriod') ? undefined : json['MinInvestmentPeriod'],
        'quoteNumber': !exists(json, 'QuoteNumber') ? undefined : json['QuoteNumber'],
        'thirdPartyViewModel': !exists(json, 'ThirdPartyViewModel') ? undefined : ThirdPartyViewModelFromJSON(json['ThirdPartyViewModel']),
        'isComplete': json['IsComplete'],
    };
}

export function JustPortfolioViewModelToJSON(value?: JustPortfolioViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProductId': value.productId,
        'CashAmount': value.cashAmount,
        'UnitAmount': value.unitAmount,
        'AssetCode': value.assetCode,
        'IncomeAmount': value.incomeAmount,
        'DisinvestmentTypeId': IAPDISINVESTMENTTYPEToJSON(value.disinvestmentTypeId),
        'SpousalInd': IAPYESORNOToJSON(value.spousalInd),
        'SpousalPerc': value.spousalPerc,
        'MinInvestmentPeriod': value.minInvestmentPeriod,
        'QuoteNumber': value.quoteNumber,
        'ThirdPartyViewModel': ThirdPartyViewModelToJSON(value.thirdPartyViewModel),
        'IsComplete': value.isComplete,
    };
}

